/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { CreateQuoteDto } from '../models/CreateQuoteDto';
import type { Quote } from '../models/Quote';
import type { UpdateQuoteStatusDto } from '../models/UpdateQuoteStatusDto';

export class QuotesService {
  /**
   * Get a quote by ID for a specific project
   * Retrieves a quote by its unique identifier, ensuring it belongs to the specified project
   * @param projectId The ID of the project the quote belongs to
   * @param id The ID of the quote to retrieve
   * @returns Quote The quote has been successfully retrieved
   * @throws ApiError
   */
  public static quotesControllerGetQuote(
    projectId: number,
    id: number,
  ): CancelablePromise<Quote> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/quotes/{projectId}/{id}',
      path: {
        projectId: projectId,
        id: id,
      },
      errors: {
        403: `The user is not allowed to access this quote or it does not belong to the project`,
        404: `The quote was not found`,
      },
    });
  }

  /**
   * Create a new quote
   * Creates a new quote for a project
   * @param requestBody
   * @returns Quote The quote has been successfully created
   * @throws ApiError
   */
  public static quotesControllerCreateQuote(
    requestBody: CreateQuoteDto,
  ): CancelablePromise<Quote> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/quotes/create',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `The user is not allowed to create a quote`,
      },
    });
  }

  /**
   * Change the status of a quote
   * @param id The ID of the quote to change the status of
   * @param requestBody
   * @returns Quote The quote status has been successfully changed
   * @throws ApiError
   */
  public static quotesControllerUpdateQuoteStatus(
    id: number,
    requestBody: UpdateQuoteStatusDto,
  ): CancelablePromise<Quote> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/quotes/{id}/status',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `This user is not allowed to update the this quote or the status change is not allowed`,
        404: `The quote was not found`,
      },
    });
  }
}
